import { createSlice } from '@reduxjs/toolkit';

import { defaultTab } from '@/constants/base';

const initialState = {
  selectedBranchId: null,
  activeTab: defaultTab,
  page: 1,
  previousTab: null,
  selectedTariff: null,
  trackId: '',
  activeSima: false,
};

const numberSale = createSlice({
  name: 'numberSale',
  initialState,
  reducers: {
    setSelectedBranchId: (state, action) => {
      state.selectedBranchId = action.payload;
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPreviousTab: (state, action) => {
      state.previousTab = action.payload;
    },
    setSelectedTariff: (state, action) => {
      state.selectedTariff = action.payload;
    },
    setTrackId: (state, action) => {
      state.trackId = action.payload;
    },
    setActiveSima: (state, action) => {
      state.activeSima = action.payload;
    },
  },
});

export const { actions } = numberSale;
export default numberSale.reducer;
